function getMimeTypeFromUrl(url: string): string {
  const extension = url.split('.').pop()?.toLowerCase();

  switch (extension) {
  case 'png':
    return 'image/png';
  case 'jpg':
  case 'jpeg':
    return 'image/jpeg';
  case 'ico':
    return 'image/x-icon';
  case 'svg':
    return 'image/svg+xml';
  default:
    return 'image/png'; // fallback
  }
}


export default function changeFavicon(url: string) {
  const type = getMimeTypeFromUrl(url);
  const head = document.head;

  // Remove favicons existentes
  document.querySelectorAll('link[rel~=\'icon\']').forEach((el) => el.remove());

  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = type;
  link.href = url;

  head.appendChild(link);
}
